<ion-card class="ion-no-margin">
  <ion-card-content class="ion-no-padding">
    <div
      class="booking-photo-container"
      (click)="onViewPhoto()"
      tappable="true"
    >
      <img
        id="bookingPhoto"
        #bookingPhoto
        [defaultImage]="THUMBNAIL_PHOTO_ROOT + '/' + photo.name"
        [lazyLoad]="BOOKING_PHOTO_ROOT + '/' + photo.name"
        errorImage="./assets/images/monster.png"
      />
    </div>
    <div class="smr-photo-date">{{ photo.date | salonMonsterDate:'dddd, MMMM D,Y' }}</div>
   

    <div
      class="note-icon-container icon-container"
      *ngIf="photo.note.length > 0"
      (click)="addNote()"
    >
      <ion-icon name="document"></ion-icon>
    </div>

    <div class="more-icon-container icon-container" (click)="showMenu($event)">
      <ion-icon name="ellipsis-horizontal"></ion-icon>
    </div>
  </ion-card-content>
</ion-card>

<!-- Menu Popover -->
<ion-popover #popover [isOpen]="isMenuOpen" (didDismiss)="isMenuOpen = false">
  <ng-template>
    <ion-content class="ion-no-padding">
      <ion-list>
        <ion-item lines="none" tappable (click)="onDownload()"
          ><ion-icon name="cloud-download"></ion-icon
          >&nbsp;&nbsp;&nbsp;&nbsp;Download</ion-item
        >
        <ion-item lines="none" tappable (click)="share()" disabled
          ><ion-icon name="share-social"></ion-icon
          >&nbsp;&nbsp;&nbsp;&nbsp;Share</ion-item
        >
        <ion-item lines="none" tappable (click)="addNote()" disabled
          ><ion-icon name="document-text"></ion-icon>&nbsp;&nbsp;&nbsp;&nbsp;Add
          a note</ion-item
        >
        <ion-item lines="none" tappable (click)="setAsProfilePic()"
          ><ion-icon name="person-circle"></ion-icon>&nbsp;&nbsp;&nbsp;&nbsp;Set
          as profile pic</ion-item
        >
        <ion-item lines="none" tappable (click)="delete()"
          ><ion-icon name="trash"></ion-icon
          >&nbsp;&nbsp;&nbsp;&nbsp;Delete</ion-item
        >
      </ion-list>
    </ion-content>
  </ng-template>
</ion-popover>
